@let link = inputLink();
@if (link) {
  @let imgUrl = image()?.url;
  @if (
    link.url && link.url.match(/^(https?:|mailto:|tel:|sms:|file:|data:|ftp:)/i)
  ) {
    @if (imgUrl) {
      <a
        class=""
        [ngClass]="inputCss()"
        [href]="link.url"
        [attr.target]="link.newWindow ? '_blank' : null"
        [attr.aria-label]="inputAriaLabel()"
        [attr.data-qa]="inputDataQa()"
      >
        <img
          [src]="imgUrl"
          [alt]="image()!.altText"
          [style.width.px]="imgWidthPx()"
          [style.height.px]="imgHeightPx()"
          [style.object-fit]="'cover'"
          [style.object-position]="
            (objectPosX() ?? '50%') + ' ' + (objectPosY() ?? '50%')
          "
        />
      </a>
    } @else {
      <a
        class=""
        [ngClass]="inputCss()"
        [href]="link.url"
        [attr.target]="link.newWindow ? '_blank' : null"
        [attr.aria-label]="inputAriaLabel()"
        [attr.data-qa]="inputDataQa()"
      >
        {{ link.label }}
      </a>
    }
  } @else {
    @if (imgUrl) {
      <button
        class="remove-style"
        [ngClass]="inputCss()"
        [routerLink]="link.url"
        [attr.aria-label]="inputAriaLabel()"
        [attr.data-qa]="inputDataQa()"
      >
        <img
          [src]="imgUrl"
          [alt]="image()!.altText"
          [style.width.px]="imgWidthPx()"
          [style.height.px]="imgHeightPx()"
          [style.object-fit]="'cover'"
          [style.object-position]="
            (objectPosX() ?? '50%') + ' ' + (objectPosY() ?? '50%')
          "
        />
      </button>
    } @else {
      <button
        class=""
        [ngClass]="inputCss()"
        [routerLink]="link.url"
        [attr.aria-label]="inputAriaLabel()"
        [attr.data-qa]="inputDataQa()"
      >
        {{ link.label }}
      </button>
    }
  }
} @else {
  <p>missing link</p>
}
